import React from 'react';
import { Heading as ElementalHeading, HeadingProps, colors } from '@plugsurfing/elemental-ui';

export const Heading = React.memo((props: HeadingProps) => (
  <ElementalHeading level={5} marginTop="1em" {...props} color={props.color || colors.fullBlack} />
));
